var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"navbar-item is-desktop-icon-only",attrs:{"title":"Deconectare"},on:{"click":_vm.logout}},[_vm._v("Deconectare ")])}
var staticRenderFns = []

export { render, staticRenderFns }